import getDefaultMenu from '../../components/Post/menu'

function getMenu(props = {}) {
    return getDefaultMenu(props).map((menu, i) => {
        if ((i === 0)) {
            const tempRole = menu.role
            menu.role = (p) => {
                const isAdmin = p.user?._status_isFeatured
                if (!isAdmin) {
                    return false
                }
                return tempRole(p)
            }
            return menu
        } else {
            if (i === 2) {
                menu.featured = true
                menu.onlyIcon = true
            }
            return menu
        }
    }).filter((menu, i) => {
        return ![3, 4, 5].includes(i)
    })
}

export function getMenuForMessages(props = {}) {
    return getDefaultMenu(props).map((menu, i) => {
        if ((i === 0)) {
            const tempRole = menu.role
            menu.role = (p) => {
                const isAdmin = p.user?._status_isFeatured
                if (!isAdmin) {
                    return false
                }
                return tempRole(p)
            }
            return menu
        } else {
            if (i === 2) {
                menu.featured = true
                menu.onlyIcon = true
            }
            return menu
        }
    }).filter((menu, i) => {
        return ![1, 3, 4, 5].includes(i)
    })
}

export default getMenu
